import React, { useCallback } from 'react';
import { DropDownButton } from 'devextreme-react';
import styled from 'styled-components';
import { color } from '@nuvolo/nuux-theme/utils';
import { useNavigate } from 'react-router-dom';
import { borderRadius } from '#/common/hooks/useClientTheme';

export interface PageDropDownButtonItem {
  key: string;
  label: string;
  path?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export interface PageDropDownButtonProps {
  label: string;
  items: PageDropDownButtonItem[];
  disabled?: boolean;
}

const StyledDropDownButton = styled(DropDownButton)`
  &&.dx-dropdownbutton {
    height: 44px;
    border-radius: ${borderRadius?.s || '16px'} !important;
    overflow: hidden;
  }

  .dx-buttongroup-item {
    background-color: ${color('secondary', 'dark2')};
    border: none;
  }

  .dx-buttongroup-item:hover,
  .dx-buttongroup-item.dx-state-hover,
  .dx-buttongroup-item.dx-state-focused,
  .dx-buttongroup-item.dx-state-active {
    background-color: ${color('secondary', 'dark2')} !important;
  }

  .dx-button-text {
    color: ${color('custom', 'invertedText')};
    text-transform: none;
  }

  .dx-icon,
  .dx-dropdownbutton-toggle-button .dx-icon,
  .dx-dropdownbutton-toggle-button .dx-icon::before {
    color: ${color('custom', 'invertedText')} !important;
  }

  .dx-button-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 20px !important;
  }
`;

const PageDropDownButton: React.FC<PageDropDownButtonProps> = ({ label, items, disabled }) => {
  const navigate = useNavigate();

  const handleItemClick = useCallback(
    (e: { itemData?: PageDropDownButtonItem }) => {
      const item = e.itemData;
      if (item?.path) {
        navigate(item.path);
      } else {
        item?.onClick?.();
      }
    },
    [navigate],
  );

  return (
    <StyledDropDownButton
      text={label}
      stylingMode="contained"
      keyExpr="key"
      displayExpr="label"
      items={items}
      disabled={disabled}
      useSelectMode={false}
      onItemClick={handleItemClick}
    />
  );
};

export default React.memo(PageDropDownButton);
